/** @jsxImportSource @emotion/react */
import React from "react";
import styled from "@emotion/styled";
import { useIsMobile } from "hooks/useDeviceType";
import { useIsTradeHistoryReturned } from "hooks/useIsTradeHistoryReturned";
import { SkeletonBlock } from "components/general/Skeleton";

export interface MonthRowContentProps {
  date: Date;
}

export const MonthRowContent: React.FC<MonthRowContentProps> = ({ date }) => {
  const isMobile = useIsMobile();
  const isTradeHistoryReturned = useIsTradeHistoryReturned();
  const text = date.toLocaleString("default", {
    month: "long",
    year: "numeric",
  });

  return (
    <MonthRowContainer isMobile={isMobile}>
      {isTradeHistoryReturned ? text : <SkeletonBlock width={130} height={18} />}
    </MonthRowContainer>
  );
};

// Sub-components

const MonthRowContainer = styled.div<{ isMobile: boolean }>`
  font-weight: 500;
  font-size: 14px;
  line-height: 120%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
  color: #f1f3f3;
  flex: none;
  order: 0;
  flex-grow: 0;
  padding: ${props => (props.isMobile ? "7px 0" : "8px 0")};
`;
